











































import { Component, Vue } from 'vue-property-decorator';

import { Typography } from '@/components/atoms';
import MarketingCenterTemplateCard from '@/components/molecules/MarketingCenterTemplateCard/MarketingCenterTemplateCard.vue';
import Page from '@/componentsV2/molecules/Page/Page.vue';

import {
  TemplatesDictionary,
  EMarketingCenterTemplates,
  IMarketingCenterTemplate
} from '@/models/marketingCenter/template';

import SpecialCoinOffersService from '@/api/SpecialCoinOffersService';

type IMarketingCenterTemplateCustom = IMarketingCenterTemplate & {
  key: string;
};

@Component({
  components: {
    Typography,
    MarketingCenterTemplateCard,
    Page
  }
})
export default class MarketingCenterTemplateSelection extends Vue {
  specialCoinOffersService = new SpecialCoinOffersService();
  specialCoinOffers: any = [];

  breadcrumbs = [
    {
      label: 'Post List',
      path: '/marketing-center/social-media-templates'
    },
    {
      label: 'Templates'
    }
  ];

  get isMobileDevice() {
    return this.$mobileCheck();
  }

  get business() {
    return this.$store.getters['business/getBusinessInfo'].business || {};
  }

  get isOutsideUS() {
    return this.business.countryIso2 !== 'US';
  }

  get templates() {
    const templates = Object.keys(TemplatesDictionary).map(key => ({
      ...TemplatesDictionary[key as EMarketingCenterTemplates],
      key
    }));

    if (this.isOutsideUS) {
      return templates.filter(template => template.key === 'loyalty-template');
    }
    return templates;
  }

  getInTouch() {
    this.$analytics({
      eventCategory: 'Social Media Assets template selection | Get In Touch',
      eventAction: 'click',
      eventLabel: 'Clicked on the "Reach out and let us know!" button'
    });

    window.location.href = 'mailto:hello@twism.com';
  }

  createPost({ key: template, title }: IMarketingCenterTemplateCustom) {
    this.$analytics({
      eventCategory: 'Social Media Assets template selection | Template type',
      eventAction: 'click',
      eventLabel: `Clicked on the "${title}" template`
    });

    this.$router.push({
      name: 'marketingCenterPostCreate',
      params: { template }
    });
  }

  returnToStart() {
    this.$router.push('/marketing-center/social-media-templates');
  }

  async getSpecialCoinOffers() {
    const response = await this.specialCoinOffersService.getOffers();
    const { items } = response.data;

    this.specialCoinOffers = items;
  }

  mounted() {
    this.getSpecialCoinOffers();
  }
}
